import React from "react";
import { Modal, ModalProps } from "react-bootstrap";
import Caution from "./../assets/img/caution.png";

interface CartRemoveModalProps extends ModalProps {
  onHide: () => void;
  handleDelete: () => void;
}

const CartConfirmationModal: React.FC<CartRemoveModalProps> = ({
  onHide,
  handleDelete,
  ...modalProps
}) => {
  const handleConfirm = () => {
    handleDelete();
    onHide();
  };

  return (
    <Modal
      {...modalProps}
      backdrop="static"
      backdropClassName="cartRemoveConfirmationBackdrop"
      className="mainMenuModal cartRemoveConfirmationModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody">
          <div>
            <img src={Caution} alt="Caution" />
          </div>
          <div className="header">Are you sure you want to remove?</div>
          <div className="d-flex align-items-center justify-content-center gap-3 mt-5">
            <button
              className="btnYesMenu"
              onClick={handleConfirm}
              onTouchStart={handleConfirm}
            >
              Yes
            </button>
            <button className="btnCancelMenu" onClick={onHide}>
              Cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CartConfirmationModal;
